import React from 'react';
import { Flame } from 'lucide-react';

// 14-day activity strip + current streak counter. `recentDays` is oldest-first.
export default function StreakStrip({ streak }) {
  if (!streak) return null;
  const days = Array.isArray(streak.recentDays) ? streak.recentDays : [];
  return (
    <div
      style={{
        background: 'var(--card-bg)',
        border: '1px solid var(--card-border)',
        borderRadius: 'var(--radius-panel)',
        padding: 'var(--space-4)',
        display: 'flex',
        gap: 'var(--space-4)',
        alignItems: 'center',
        flexWrap: 'wrap',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
        <span
          style={{
            width: 36,
            height: 36,
            borderRadius: 'var(--radius-md)',
            background: streak.currentDays > 0 ? 'var(--warning-bg)' : 'var(--bg-tertiary)',
            color: streak.currentDays > 0 ? 'var(--warning)' : 'var(--text-secondary)',
            display: 'grid',
            placeItems: 'center',
          }}
        >
          <Flame size={18} strokeWidth={1.5} />
        </span>
        <div>
          <div
            style={{
              fontSize: 'var(--text-label-size)',
              fontWeight: 700,
              color: 'var(--text-tertiary)',
              textTransform: 'uppercase',
              letterSpacing: 'var(--text-label-tracking)',
              marginBottom: 'var(--space-1)',
            }}
          >
            Streak
          </div>
          <div
            style={{
              fontSize: 'var(--text-section-size)',
              fontWeight: 800,
              color: 'var(--text-primary)',
            }}
          >
            {streak.currentDays}{' '}
            <span style={{ fontSize: 'var(--text-body-size)', fontWeight: 600, color: 'var(--text-tertiary)' }}>
              day{streak.currentDays === 1 ? '' : 's'}
            </span>
          </div>
        </div>
      </div>

      <div
        style={{
          flex: 1,
          minWidth: 200,
          display: 'grid',
          gridTemplateColumns: `repeat(${Math.max(days.length, 14)}, 1fr)`,
          gap: 'var(--space-1)',
        }}
        aria-label="Recent 14-day training activity"
      >
        {days.map((active, i) => (
          <div
            key={i}
            title={`Day ${i + 1}: ${active ? 'trained' : 'skipped'}`}
            style={{
              aspectRatio: '1',
              borderRadius: 4,
              background: active ? 'var(--accent-primary)' : 'var(--border-subtle)',
              opacity: active ? 0.85 : 1,
            }}
          />
        ))}
      </div>
    </div>
  );
}
